(function () {
  'use strict';
  const KEY = 'limitless-enquiry-opt-in-v1';
  const AGE = 30 * 60 * 1000;
  function read() { try { return JSON.parse(sessionStorage.getItem(KEY)); } catch (_) { return null; } }
  function clear() { try { sessionStorage.removeItem(KEY); } catch (_) {} }
  function save(value) { sessionStorage.setItem(KEY, JSON.stringify(value)); if (!sessionStorage.getItem(KEY)) throw new Error('Storage unavailable'); }
  function valid(value) { return value && value.path === location.pathname && typeof value.email === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.email) && Number.isFinite(value.at) && Date.now() >= value.at && Date.now() - value.at < AGE; }
  function show(mode) {
    const panel = document.querySelector('[data-limitless-email-confirmation]');
    if (!panel) return;
    panel.hidden = false;
    panel.querySelector('[data-limitless-email-pending]').hidden = mode !== 'pending';
    panel.querySelector('[data-limitless-email-success]').hidden = mode !== 'success';
    panel.querySelector('[data-limitless-email-retry]').hidden = mode !== 'retry';
  }
  document.addEventListener('submit', function (event) {
    const form = event.target;
    const consent = form && form.querySelector('[data-limitless-email-consent]');
    if (!consent || !form.checkValidity()) return;
    const email = form.querySelector('input[type="email"]');
    if (!email) return;
    if (!consent.checked) { clear(); return; }
    const pending = {email: email.value.trim(), formId: form.id, path: location.pathname, at: Date.now(), stage: 'enquiry'};
    const time = form.querySelector('[data-limitless-consent-time]');
    if (time) time.value = new Date(pending.at).toISOString();
    try { save(pending); }
    catch (_) { event.preventDefault(); form.querySelector('[data-limitless-consent-error]').hidden = false; }
  }, true);
  function finish() {
    document.querySelectorAll('[data-limitless-email-consent]').forEach(function (choice) { choice.disabled = false; });
    const pending = read();
    if (!valid(pending)) { if (pending) clear(); return; }
    const signup = document.getElementById('LimitlessEnquiryEmailSignup');
    if (!signup) return;
    signup.elements['contact[email]'].value = pending.email;
    const route = pending.path.split('/').pop().replace(/[^a-z0-9-]/g, '').slice(0,70) || 'enquiry';
    signup.elements['contact[tags]'].value = 'limitless-email-opt-in-v1,limitless-source-' + route;
    const subscriptionResult = signup.querySelector('[data-limitless-subscription-result]');
    if (pending.stage === 'subscription') {
      if (subscriptionResult && subscriptionResult.dataset.limitlessSubscriptionResult === 'success') { clear(); show('success'); }
      else { show('retry'); }
      return;
    }
    const enquiry = document.getElementById(pending.formId);
    const enquiryResult = enquiry && enquiry.querySelector('[data-limitless-contact-result]');
    if (!enquiryResult || enquiryResult.dataset.limitlessContactResult !== 'success') return;
    pending.stage = 'subscription';
    try { save(pending); } catch (_) { show('retry'); return; }
    show('pending');
    const submit = function () { signup.requestSubmit(); };
    if (window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect) window.Shopify.captcha.protect(signup, submit);
    else { show('retry'); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', finish, {once:true}); else finish();
})();
